import React, { memo } from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';
import { subject } from '@casl/ability';
import { useAbility } from '@casl/react';
import ErrorBoundary from '../ErrorBoundary';
import { AbilityContext } from '../../casl/AbilityContext';

function EventGroupProtectedLayout() {
  const { id } = useParams();
  const ability = useAbility(AbilityContext);
  const canReadEventGroup =
    ability.can('read', 'EventGroup') ||
    ability.can('read', subject('EventGroup', { id: Number(id) })); // Ensure id is a number
  if (!canReadEventGroup) {
    // return <NoAccessText />;
    return <Navigate to="/" replace />;
  }

  return (
    <ErrorBoundary>
      <Outlet />
    </ErrorBoundary>
  );
}

export default memo(EventGroupProtectedLayout);
